import React, { memo } from "react";
import { Translate } from "react-redux-i18n";

const Translator = ({ value, count, primaryValue, secondaryValue, style, name }) => {
	return (
		<Translate
			value={value}
			count={count != undefined ? count : ""}
			name={name !== undefined ? name : ""}
			primaryValue={primaryValue != undefined ? primaryValue : ""}
			secondaryValue={secondaryValue != undefined ? secondaryValue : ""}
			style={style}
		/>
	);
};

export default memo(Translator);
